import { usePlatformStore, TOOLS, type ToolId } from '@/stores/platformStore'

const TOOL_DETAILS: Record<Exclude<ToolId, 'home'>, { tagline: string; color: string }> = {
  exmarked: {
    tagline: 'Browse connected GitHub repositories and read Markdown documents with rich formatting, table of contents, and export to Word.',
    color:   'var(--gold)',
  },
  cast: {
    tagline: 'Generate AI-driven marketing videos via prompt using Google Veo. Produce, sequence, and export production-ready content.',
    color:   'var(--ember)',
  },
  foundry: {
    tagline: 'Manage the characters, scenes, and visual assets that power Cast productions. Build and organise your creative library.',
    color:   'var(--amber)',
  },
}

export function HomeLanding() {
  const setActiveTool = usePlatformStore((s) => s.setActiveTool)

  return (
    <div className="h-full overflow-y-auto bg-forge-void flex flex-col items-center justify-center px-8 py-16">

      {/* Wordmark */}
      <div className="flex flex-col items-center mb-14">
        <div className="w-14 h-14 rounded-2xl bg-forge-ember flex items-center justify-center mb-5 shadow-lg shadow-forge-ember/30">
          <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2.5"
               strokeLinecap="round" strokeLinejoin="round">
            <path d="M12 2L2 7l10 5 10-5-10-5z" />
            <path d="M2 17l10 5 10-5" />
            <path d="M2 12l10 5 10-5" />
          </svg>
        </div>
        <h1 className="font-display font-bold text-3xl tracking-[0.2em] text-forge-gold uppercase">
          Smithy
        </h1>
        <p className="text-forge-ash text-xs tracking-[0.25em] uppercase mt-2">
          The Forge Platform
        </p>
      </div>

      {/* Tool cards */}
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-5 w-full max-w-3xl">
        {TOOLS.map((tool) => {
          const details = TOOL_DETAILS[tool.id as Exclude<ToolId, 'home'>]
          return (
            <button
              key={tool.id}
              onClick={() => setActiveTool(tool.id)}
              className="group relative flex flex-col bg-forge-basalt border border-forge-border rounded-xl p-6 text-left
                         hover:border-forge-ember/50 hover:bg-forge-basalt/80 transition-all duration-200
                         shadow-lg hover:shadow-forge-ember/10"
            >
              {/* Icon */}
              <div
                className="w-10 h-10 rounded-lg flex items-center justify-center mb-5 transition-colors duration-200"
                style={{ background: `color-mix(in srgb, ${details.color} 12%, transparent)` }}
              >
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke={details.color}
                     strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                  <path d={tool.icon} />
                </svg>
              </div>

              {/* Name + description */}
              <div className="font-display font-bold text-sm text-forge-primary mb-1 uppercase tracking-wider">
                {tool.name}
              </div>
              <div className="text-[10px] font-semibold uppercase tracking-widest mb-3"
                   style={{ color: details.color }}>
                {tool.description}
              </div>
              <p className="text-xs text-forge-ash leading-relaxed flex-1">
                {details.tagline}
              </p>

              {/* Launch CTA */}
              <div className="mt-5 flex items-center gap-1.5 text-[11px] font-semibold uppercase tracking-wider text-forge-ash
                              group-hover:text-forge-primary transition-colors duration-150">
                Launch
                <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                     strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M5 12h14M12 5l7 7-7 7" />
                </svg>
              </div>
            </button>
          )
        })}
      </div>
    </div>
  )
}
